import { useEffect } from 'react'

export interface ShortcutOptions {
    altKey?: boolean
    ctrlKey?: boolean
    metaKey?: boolean
    shiftKey?: boolean
    enabled?: boolean
}

export function useKeyboardShortcut(key: string, callback: (event: KeyboardEvent) => void, options: ShortcutOptions = {}) {
    useEffect(() => {
        if (options.enabled === false) return
        const handleKeyDown = (event: KeyboardEvent) => {
            const { altKey = false, ctrlKey = false, metaKey = false, shiftKey = false } = options

            if (
                event.key.toLowerCase() === key.toLowerCase() &&
                event.altKey === altKey &&
                event.ctrlKey === ctrlKey &&
                event.metaKey === metaKey &&
                event.shiftKey === shiftKey
            ) {
                event.preventDefault()
                callback(event)
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [key, callback, options])
}
